var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

import "./FieldSuggest.scss";

var FieldSuggest = (_temp2 = _class = function (_Component) {
    _inherits(FieldSuggest, _Component);

    function FieldSuggest() {
        var _temp, _this, _ret;

        _classCallCheck(this, FieldSuggest);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            value: ""
        }, _this.onChange = function (event, _ref) {
            var newValue = _ref.newValue;


            if (_this.props.onChange) {
                _this.props.onChange(newValue, event);
            }
        }, _this.onFetchRequested = function (_ref2) {
            var value = _ref2.value;


            if (_this.props.onSuggest) {
                _this.props.onSuggest(value);
            }
        }, _this.onClearRequested = function () {

            if (_this.props.onSuggest) {
                _this.props.onSuggest();
            }
        }, _this.onSelect = function (item) {

            if (_this.props.onSelect) {
                return _this.props.onSelect(item);
            }

            return item;
        }, _this.renderSuggestion = function (item) {

            if (_this.props.renderItem) {
                return _this.props.renderItem(item);
            }

            return React.createElement(
                React.Fragment,
                null,
                JSON.stringify(item)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FieldSuggest.prototype.render = function render() {
        var _props = this.props,
            placeholder = _props.placeholder,
            value = _props.value,
            suggestions = _props.suggestions;


        var theme = {
            container: 'admin-field--suggest',
            containerOpen: 'admin-field--suggest--open',
            input: 'admin-field__input',
            inputOpen: 'admin-field__input--open',
            inputFocused: 'admin-field__input--focus',
            itemsContainer: 'admin-field__suggest',
            itemsContainerOpen: 'admin-field__suggest--open',
            itemsList: 'admin-field__suggest-list',
            item: 'admin-field__suggest-item',
            itemFirst: 'admin-field__suggest-item--first',
            itemHighlighted: 'admin-field__suggest-item--highlight',
            sectionContainer: 'admin-field__suggest-section',
            sectionContainerFirst: 'admin-field__suggest-section--first',
            sectionTitle: 'admin-field__suggest-section__title'
        };

        var inputProps = {
            placeholder: placeholder,
            value: value,
            onChange: this.onChange
        };

        return React.createElement(Autosuggest, {
            theme: theme,
            suggestions: suggestions,
            onSuggestionsFetchRequested: this.onFetchRequested,
            onSuggestionsClearRequested: this.onClearRequested,
            getSuggestionValue: this.onSelect,
            renderSuggestion: this.renderSuggestion,
            inputProps: inputProps
        });
    };

    return FieldSuggest;
}(Component), _class.defaultProps = {
    suggestions: [],
    value: "",
    placeholder: ""
}, _temp2);


export default FieldSuggest;